"use client"

import { PackageOpen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PackageOpenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PackageOpenIcon = component(Icon)({ as: PackageOpen })
